import { makeStyles } from "@material-ui/core/styles";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { useCallback, useState } from "react";
import AscScale from "../layers/AscScale";
import { weatherTimeWithID, WX_ID_ASCSCALE } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";
import { configAscScaleLayer } from "../layers/config/ConfigAscScale";

const config = configAscScaleLayer.Attributes.style.default;
const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'column',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  columnBox: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  checkLabel: {
    display: 'inline-block',
    width: '62px',
    textAlign: 'left',
    fontSize:"12px"
  },
  iconWrap: {
    width: "40px",
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle"
  },
  iconMini: {
    height: "22px"
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    whiteSpace: "nowrap"
  },
  block: {
    display: 'inline-block',
    width: '9px',
    height: '9px',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  turbSev: {
    backgroundColor: config.turb_sev_color
  },
  turbModToSev: {
    backgroundColor: config.turb_mod_to_sev_color
  },
  turbMod: {
    backgroundColor: config.turb_mod_color
  },
  convMod: {
    backgroundColor: config.conv_mod_color
  },
  convLgt: {
    backgroundColor: config.conv_lgt_color
  },
  iceMod: {
    backgroundColor: config.icing_mod_color
  },
  iceLgt: {
    backgroundColor: config.icing_lgt_color
  }
}));

function LegendAscScale({contents: ascScale}) {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_ASCSCALE));
  const [contentsState, setContentsState] = useState(ascScale.getContentsVisibleState());

  const toggleContents = useCallback(event => {
    ascScale.setContentsVisible(event.target.name, event.target.checked);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [ascScale, contentsState]);

  return (
    <div className={classes.box}>
      <div className="legend-contents-time">
        {timeInfo.validTime}&nbsp;{timeInfo.baseTime}
      </div>
      <ul className={classes.columnBox}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[AscScale.TURBULENCE_NAME]} onChange={toggleContents} name={AscScale.TURBULENCE_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Turbulence</span>}
          />
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbSev}`}/></span><span className={classes.label}>SEV</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbModToSev}`}/></span><span className={classes.label}>MODtoSEV</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.turbMod}`}/></span><span className={classes.label}>MOD</span>
        </li>
      </ul>
      <ul className={classes.columnBox}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[AscScale.CONVECTION_NAME]} onChange={toggleContents} name={AscScale.CONVECTION_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Convection</span>}
          />
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.convMod}`}/></span><span className={classes.label}>MOD</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.convLgt}`}/></span><span className={classes.label}>LGT</span>
        </li>
      </ul>
      <ul className={classes.columnBox}>
        <li className={classes.item}>
          <FormControlLabel
            control={<Checkbox checked={contentsState[AscScale.ICING_NAME]} onChange={toggleContents} name={AscScale.ICING_NAME} size='small'/>}
            label={<span className={classes.checkLabel}>Icing</span>}
          />
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.iceMod}`}/></span><span className={classes.label}>MOD</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><span className={`${classes.block} ${classes.iceLgt}`}/></span><span className={classes.label}>LGT</span>
        </li>
      </ul>
    </div>
  );
}

export default LegendAscScale;